import {
    ADD_FAVOURITE_ORG_SURVEY,
    FETCH_ALL_ORG_SURVEY,
    FETCH_ALL_ORG_SURVEY_SUCCESS,
    FILTER_ORG_SURVEY,
    GET_ALL_ORG_SURVEY,
    GET_UNSELECTED_ALL_ORG_SURVEY,
    HANDLE_ORG_SURVEY_REQUEST_CLOSE,
    HIDE_ORG_SURVEY_LOADER,
    SHOW_ORG_SURVEY_LOADER,
    ON_ADD_ORG_SURVEY,
    ON_ALL_ORG_SURVEY_SELECT,
    ON_ORG_SURVEY_CLOSE,
    ON_ORG_SURVEY_SELECT,
    ON_DELETE_ORG_SURVEY,
    ON_DELETE_SELECTED_ORG_SURVEY,
    ON_FILTER_ORG_SURVEY_OPTION_SELECT,
    ON_SAVE_ORG_SURVEY,
    ON_SAVE_ORG_SURVEY_SUCCESS,
    ON_TOGGLE_ORG_SURVEY_DRAWER,
    SHOW_ORG_SURVEY_MESSAGE,
    UPDATE_SEARCH_ORG_SURVEY,
    ON_ORG_SURVEY_QUESTIONS,
    ON_ORG_SURVEY_COMPARE_SELECT,
    FETCH_ALL_ORG_SURVEY_COMPARE,
    FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS,
    FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA,
    FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA,
    FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS,
    FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA,
    FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS,
    FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA,
    FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS,
    FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS,
    FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA,
    FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS,
} from 'constants/ActionTypes';

export const onOrgSurveyQuestions = (data) => {
    return {
        type: ON_ORG_SURVEY_QUESTIONS,
        payload: data
    };
};
export const fetchOrgSurveys = () => {
    return {
        type: FETCH_ALL_ORG_SURVEY
    };
};

export const fetchOrgSurveysSuccess = (data) => {
    return {
        type: FETCH_ALL_ORG_SURVEY_SUCCESS,
        payload: data
    };
};
export const showOrgSurveyMessage = (message) => {
    return {
        type: SHOW_ORG_SURVEY_MESSAGE,
        payload: message
    };
};
export const addFavouriteOrgSurvey = (data) => {
    return {
        type: ADD_FAVOURITE_ORG_SURVEY,
        payload: data
    };
};
export const onOrgSurveySelect = (data) => {
    return {
        type: ON_ORG_SURVEY_SELECT,
        payload: data
    };
};
export const onOrgSurveyCompareSelect = (data) => {
    return {
        type: ON_ORG_SURVEY_COMPARE_SELECT,
        payload: data
    };
};
export const fetchOrgSurveysCompare = () => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE
    };
};
export const fetchOrgSurveysCompareSuccess = (payload) => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS,
        payload
    };
};
export const fetchOrgSurveysCompareRadarChartData = () => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA
    };
};
export const fetchOrgSurveysEngagementReportChartData = () => {
    return {
        type: FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA
    };
};
export const fetchOrgSurveysEngagementReportChartDataSuccess = (payload) => {
    return {
        type: FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS,
        payload
    };
};
export const fetchOrgSurveysDistributionsChartData = () => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA
    };
};
export const fetchOrgSurveysCompareDistributionsChartDataSuccess = (payload) => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS,
        payload
    };
};
export const fetchOrgSurveysTopResultsChartData = () => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA
    };
};
export const fetchOrgSurveysCompareTopResultsChartDataSuccess = (payload) => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS,
        payload
    };
};
export const fetchOrgSurveysBottomResultsChartData = () => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA
    };
};
export const fetchOrgSurveysCompareBottomResultsChartDataSuccess = (payload) => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS,
        payload
    };
};
export const fetchOrgSurveysCompareRadarChartDataSuccess = (payload) => {
    return {
        type: FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS,
        payload
    };
};
export const onAddOrgSurvey = () => {
    return {
        type: ON_ADD_ORG_SURVEY,
        payload: ''
    };
};
export const onOrgSurveyClose = () => {
    return {
        type: ON_ORG_SURVEY_CLOSE,
        payload: ''
    };
};
export const onFilterOrgSurveyOptionSelect = (option) => {
    return {
        type: ON_FILTER_ORG_SURVEY_OPTION_SELECT,
        payload: option
    };
};
export const onSaveOrgSurvey = (data) => {
    return {
        type: ON_SAVE_ORG_SURVEY,
        payload: data
    };
};
export const onSaveOrgSurveySuccess = (data) => {
    return {
        type: ON_SAVE_ORG_SURVEY_SUCCESS,
        payload: data
    };
};
export const onDeleteOrgSurvey = (data) => {
    return {
        type: ON_DELETE_ORG_SURVEY,
        payload: data
    };
};
export const onDeleteSelectedOrgSurvey = () => {
    return {
        type: ON_DELETE_SELECTED_ORG_SURVEY,
        payload: ''
    };
};
export const filterOrgSurvey = (userName) => {
    return {
        type: FILTER_ORG_SURVEY,
        payload: userName
    };
};
export const getAllOrgSurvey = () => {
    return {
        type: GET_ALL_ORG_SURVEY,
        payload: ''
    };
};
export const getUnselectedAllOrgSurvey = () => {
    return {
        type: GET_UNSELECTED_ALL_ORG_SURVEY,
        payload: ''
    };
};
export const onAllOrgSurveySelect = () => {
    return {
        type: ON_ALL_ORG_SURVEY_SELECT,
        payload: ''
    };
};
export const updateSearchOrgSurvey = (userName) => {
    return {
        type: UPDATE_SEARCH_ORG_SURVEY,
        payload: userName
    };
};
export const onToggleOrgSurveyDrawer = () => {
    return {
        type: ON_TOGGLE_ORG_SURVEY_DRAWER,
    };
};
export const handleOrgSurveyRequestClose = () => {
    return {
        type: HANDLE_ORG_SURVEY_REQUEST_CLOSE,
    };
};
export const showOrgSurveyLoader = () => {
    return {
        type: SHOW_ORG_SURVEY_LOADER,
    };
};
export const hideOrgSurveyLoader = () => {
    return {
        type: HIDE_ORG_SURVEY_LOADER,
    };
};



// WEBPACK FOOTER //
// ./actions/OrgSurvey.js